import {
  getAllWorkshopsForAdmin,
  getWorkshopById,
  createWorkshop,
  updateWorkshop,
  deleteWorkshop,
  getWorkshopRegistrations,
  updateRegistrationStatus,
  getWorkshopsStatistics,
  getPublicWorkshops,
  getPublicWorkshopById,
  registerForWorkshop,
  getUserWorkshopRegistrations,
  getWorkshopSchedulesBySKU,
} from "./asyncThunk";

export const getAllWorkshopsForAdminBuilder = (builder) => {
  builder.addCase(getAllWorkshopsForAdmin.pending, (state) => {
    state.workshops.loading = true;
    state.workshops.error = null;
  });
  builder.addCase(getAllWorkshopsForAdmin.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.workshops.data = data.workshops;
    state.workshops.pagination = data.pagination;
    state.workshops.loading = false;
  });
  builder.addCase(getAllWorkshopsForAdmin.rejected, (state, action) => {
    state.workshops.error = action.error.message;
    state.workshops.loading = false;
  });
};

export const getWorkshopByIdBuilder = (builder) => {
  builder.addCase(getWorkshopById.pending, (state) => {
    state.currentWorkshop.loading = true;
    state.currentWorkshop.error = null;
  });
  builder.addCase(getWorkshopById.fulfilled, (state, { payload }) => {
    state.currentWorkshop.data = payload.data.workshop;
    state.currentWorkshop.loading = false;
  });
  builder.addCase(getWorkshopById.rejected, (state, action) => {
    state.currentWorkshop.error = action.error.message;
    state.currentWorkshop.loading = false;
  });
};

export const createWorkshopBuilder = (builder) => {
  builder.addCase(createWorkshop.pending, (state) => {
    state.workshopActions.creating = true;
    state.workshopActions.error = null;
  });
  builder.addCase(createWorkshop.fulfilled, (state, { payload }) => {
    state.workshops.data.unshift(payload.data.workshop);
    state.workshopActions.creating = false;
  });
  builder.addCase(createWorkshop.rejected, (state, action) => {
    state.workshopActions.error = action.error.message;
    state.workshopActions.creating = false;
  });
};

export const updateWorkshopBuilder = (builder) => {
  builder.addCase(updateWorkshop.pending, (state, { meta }) => {
    const workshopId = meta.arg.id;
    state.workshopActions.updating[workshopId] = true;
    state.workshopActions.error = null;
  });
  builder.addCase(updateWorkshop.fulfilled, (state, { payload, meta }) => {
    const workshopId = meta.arg.id;
    const updatedWorkshop = payload.data.workshop;
    state.workshops.data = state.workshops.data.map(workshop =>
      workshop.id === updatedWorkshop.id ? updatedWorkshop : workshop
    );
    if (state.currentWorkshop.data?.id === updatedWorkshop.id) {
      state.currentWorkshop.data = updatedWorkshop;
    }
    state.workshopActions.updating[workshopId] = false;
  });
  builder.addCase(updateWorkshop.rejected, (state, { meta, action }) => {
    const workshopId = meta.arg.id;
    state.workshopActions.error = action.error.message;
    state.workshopActions.updating[workshopId] = false;
  });
};

export const deleteWorkshopBuilder = (builder) => {
  builder.addCase(deleteWorkshop.pending, (state, { meta }) => {
    const workshopId = meta.arg;
    state.workshopActions.deleting[workshopId] = true;
    state.workshopActions.error = null;
  });
  builder.addCase(deleteWorkshop.fulfilled, (state, { meta }) => {
    const workshopId = meta.arg;
    state.workshops.data = state.workshops.data.filter(workshop => workshop.id !== workshopId);
    if (state.currentWorkshop.data?.id === workshopId) {
      state.currentWorkshop.data = null;
    }
    state.workshopActions.deleting[workshopId] = false;
  });
  builder.addCase(deleteWorkshop.rejected, (state, { meta, action }) => {
    const workshopId = meta.arg;
    state.workshopActions.error = action.error.message;
    state.workshopActions.deleting[workshopId] = false;
  });
};

export const getWorkshopRegistrationsBuilder = (builder) => {
  builder.addCase(getWorkshopRegistrations.pending, (state) => {
    state.registrations.loading = true;
    state.registrations.error = null;
  });
  builder.addCase(getWorkshopRegistrations.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.registrations.data = data.registrations;
    state.registrations.workshop = data.workshop;
    state.registrations.loading = false;
  });
  builder.addCase(getWorkshopRegistrations.rejected, (state, action) => {
    state.registrations.error = action.error.message;
    state.registrations.loading = false;
  });
};

export const updateRegistrationStatusBuilder = (builder) => {
  builder.addCase(updateRegistrationStatus.pending, (state, { meta }) => {
    const registrationId = meta.arg.registrationId;
    state.registrationActions.updating[registrationId] = true;
  });
  builder.addCase(updateRegistrationStatus.fulfilled, (state, { payload, meta }) => {
    const registrationId = meta.arg.registrationId;
    const updatedRegistration = payload.data.registration;
    state.registrations.data = state.registrations.data.map(registration =>
      registration.id === updatedRegistration.id ? updatedRegistration : registration
    );
    state.registrationActions.updating[registrationId] = false;
  });
  builder.addCase(updateRegistrationStatus.rejected, (state, { meta }) => {
    const registrationId = meta.arg.registrationId;
    state.registrationActions.updating[registrationId] = false;
  });
};

export const getWorkshopsStatisticsBuilder = (builder) => {
  builder.addCase(getWorkshopsStatistics.pending, (state) => {
    state.statistics.loading = true;
    state.statistics.error = null;
  });
  builder.addCase(getWorkshopsStatistics.fulfilled, (state, { payload }) => {
    state.statistics.data = payload.data.statistics;
    state.statistics.loading = false;
  });
  builder.addCase(getWorkshopsStatistics.rejected, (state, action) => {
    state.statistics.error = action.error.message;
    state.statistics.loading = false;
  });
};

export const getPublicWorkshopsBuilder = (builder) => {
  builder.addCase(getPublicWorkshops.pending, (state) => {
    state.publicWorkshops.loading = true;
    state.publicWorkshops.error = null;
  });
  builder.addCase(getPublicWorkshops.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.publicWorkshops.data = data.workshops;
    state.publicWorkshops.pagination = data.pagination;
    state.publicWorkshops.loading = false;
  });
  builder.addCase(getPublicWorkshops.rejected, (state, action) => {
    state.publicWorkshops.error = action.error.message;
    state.publicWorkshops.loading = false;
  });
};

export const getPublicWorkshopByIdBuilder = (builder) => {
  builder.addCase(getPublicWorkshopById.pending, (state) => {
    state.currentPublicWorkshop.loading = true;
    state.currentPublicWorkshop.error = null;
  });
  builder.addCase(getPublicWorkshopById.fulfilled, (state, { payload }) => {
    state.currentPublicWorkshop.data = payload.data.workshop;
    state.currentPublicWorkshop.loading = false;
  });
  builder.addCase(getPublicWorkshopById.rejected, (state, action) => {
    state.currentPublicWorkshop.error = action.error.message;
    state.currentPublicWorkshop.loading = false;
  });
};

export const registerForWorkshopBuilder = (builder) => {
  builder.addCase(registerForWorkshop.pending, (state) => {
    state.registration.loading = true;
    state.registration.error = null;
  });
  builder.addCase(registerForWorkshop.fulfilled, (state, { payload }) => {
    state.registration.data = payload.data.registration;
    state.registration.loading = false;
    state.registration.success = true;
  });
  builder.addCase(registerForWorkshop.rejected, (state, action) => {
    state.registration.error = action.error.message;
    state.registration.loading = false;
    state.registration.success = false;
  });
};

export const getUserWorkshopRegistrationsBuilder = (builder) => {
  builder.addCase(getUserWorkshopRegistrations.pending, (state) => {
    state.userRegistrations.loading = true;
    state.userRegistrations.error = null;
  });
  builder.addCase(getUserWorkshopRegistrations.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.userRegistrations.data = data.registrations;
    state.userRegistrations.pagination = data.pagination;
    state.userRegistrations.loading = false;
  });
  builder.addCase(getUserWorkshopRegistrations.rejected, (state, action) => {
    state.userRegistrations.error = action.error.message;
    state.userRegistrations.loading = false;
  });
};

export const getWorkshopSchedulesBySKUBuilder = (builder) => {
  builder.addCase(getWorkshopSchedulesBySKU.pending, (state) => {
    state.workshopSchedules.loading = true;
    state.workshopSchedules.error = null;
    // Očisti prethodne termine da se ne prikažu/rezervišu termini prošle
    // radionice dok se učitavaju novi (spreči rezervaciju pogrešnog termina).
    state.workshopSchedules.data = [];
  });
  builder.addCase(getWorkshopSchedulesBySKU.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.workshopSchedules.data = data.schedules;
    state.workshopSchedules.loading = false;
  });
  builder.addCase(getWorkshopSchedulesBySKU.rejected, (state, action) => {
    state.workshopSchedules.error = action.error.message;
    state.workshopSchedules.loading = false;
  });
};